import React, { useState } from "react";
import { Link } from "react-router-dom";
import destinations from "../data/destinations.json";

const Navigation = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Dropdown toggle
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // Mobile menu toggle

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="text-2xl font-bold text-blue-500">
              TravelNow
            </Link>
          </div>

          {/* Hamburger Menu for Mobile */}
          <div className="flex md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 hover:text-blue-500 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* Links for Desktop */}
          <div className="hidden md:flex space-x-8 items-center">
            <Link to="/" className="text-gray-700 hover:text-blue-500">
              Home
            </Link>
            <div className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="flex items-center text-gray-700 hover:text-blue-500 focus:outline-none"
              >
                Destinations
              </button>
              {isDropdownOpen && (
                <div className="absolute left-0 top-full mt-2 w-48 bg-white shadow-lg rounded-md z-10">
                  {destinations.map((destination) => (
                    <Link
                      key={destination.id}
                      to={`/destinations/${destination.name.toLowerCase()}`}
                      className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white"
                    >
                      {destination.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link to="/about" className="text-gray-700 hover:text-blue-500">
              About
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-blue-500">
              Contact
            </Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white shadow-md rounded-lg">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white"
            >
              Home
            </Link>
            <div>
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white w-full text-left"
              >
                Destinations
              </button>
              {isDropdownOpen && (
                <div className="bg-white shadow-lg rounded-md">
                  {destinations.map((destination) => (
                    <Link
                      key={destination.id}
                      to={`/destinations/${destination.name.toLowerCase()}`}
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white"
                    >
                      {destination.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white"
            >
              About
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white"
            >
              Contact
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
